export default __webpack_public_path__ + "static/media/Nav-Down.fe34423f.svg";